import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import styled from 'styled-components';
import { connect } from 'react-redux';
import {
  setCategories,
  setPublishedDates,
  setDocumentTypes,
  setDocumentSources
} from 'filters/actions';
import dataService from 'api/dataService';
import { getData, dataReceived } from 'datahub/actions';
import { filterData, resetCategories } from 'filters/selectors';
import { CheckboxTree } from 'components/layouts';
import { RoundedButton, TransparentButton, Text } from 'components/styled/ui';
import { media } from 'components/styled/utils';
import DocumentType from './documentType';
import DocumentSource from './documentSource';
import PublishedDates from './publishedDates';
import $ from 'jquery';
import { images, strings } from 'config';

class AdvancedFilters extends Component {
  constructor() {
    super();
    this.state = {
      selectedFilters: {
        categories: {},
        publishedDates: [],
        documentTypes: [],
        documentSources: []
      },
      data: {
        publishedDates: [],
        documentTypes: [],
        documentSources: []
      },
      filterOpen: false
    };

    this.filters = this.state.selectedFilters;
  }

  componentDidMount() {
    dataService.getCategories().then(response => {
      this.getAdvancedFilters(response);
    });
  }

  componentWillReceiveProps(nextProps) {
    const { filters } = nextProps;
    this.setState(
      {
        selectedFilters: {
          categories: filters.categories,
          publishedDates: filters.publishedDates,
          documentTypes: filters.documentTypes,
          documentSources: filters.documentSources
        }
      },
      () => {
        this.filters = this.state.selectedFilters;
      }
    );
  }

  getAdvancedFilters(response) {
    this.setState({
      data: {
        publishedDates: response.published_year,
        documentTypes: response.document_types,
        documentSources: response.document_source
      }
    });
  }

  slideToggleFilters() {
    var self = this;
    $(ReactDOM.findDOMNode(this.refs.filterSidebar))
      .find('.toggle-button')
      .click(function() {
        $(ReactDOM.findDOMNode(self.refs.filterSidebar)).toggleClass('expanded');
      });
  }

  onCategoriesChange = categories => {
    this.filters['categories'] = categories;
    this.setState({
      selectedFilters: this.filters
    });
  };

  onDatesChange = dates => {
    this.filters['publishedDates'] = dates;
    this.setState({
      selectedFilters: this.filters
    });
  };

  onTypesChanged = types => {
    this.filters['documentTypes'] = types;
    this.setState({
      selectedFilters: this.filters
    });
  };

  onSourcesChanged = sources => {
    this.filters['documentSources'] = sources;
    this.setState({
      selectedFilters: this.filters
    });
  };

  applyFilters = () => {
    const { filters, handleFilters } = this.props;
    const {
      categories,
      publishedDates,
      documentTypes,
      documentSources
    } = this.state.selectedFilters;
    const filteredResult = {
      ...filters,
      ...{ categories, publishedDates, documentTypes, documentSources }
    };
    handleFilters(filteredResult);
    this.setState({ filterOpen: false });
  };

  resetFilters = () => {
    const { filters, handleFilters } = this.props;
    const { selectedFilters } = this.state;

    const initialCategories = resetCategories(selectedFilters.categories);
    const initialPublishedDates = [];
    const initialdocumentSources = [];
    const initialdocumentTypes = [];

    const filteredResult = {
      ...filters,
      ...{
        categories: initialCategories,
        publishedDates: initialPublishedDates,
        documentTypes: initialdocumentTypes,
        documentSources: initialdocumentSources
      }
    };
    handleFilters(filteredResult);
    this.setState({ filterOpen: false });
  };

  toggleFilter = () => {
    this.setState(
      {
        filterOpen: !this.state.filterOpen
      },
      () => {
        $('body').toggleClass('overflow-hidden');
      }
    );
  };

  render() {
    const { data, filterOpen } = this.state;
    const { dataList } = this.props;

    return (
      <Content ref="filterSidebar" lang={strings.getLanguage()}>
        <div className="toggle-actions" onClick={this.toggleFilter}>
          <RoundedButton className="toggle-button">
            <img src={images.icons.filter} alt="" />
            {strings.filters.filterToggle}
          </RoundedButton>
        </div>
        {filterOpen && <BackgroundShadow onClick={this.toggleFilter} />}

        <div className={filterOpen ? 'filter-sidebar is-active' : 'filter-sidebar'}>
          <div className="heading">
            <Text.span light size={16}>
              {strings.filters.filterTitle}
            </Text.span>
            <img src={images.icons.cross} alt="" onClick={this.toggleFilter} />
          </div>
          <DocumentType
            dataList={dataList.data}
            onTypesChanged={this.onTypesChanged}
            data={data.documentTypes}
          />
          <DocumentSource
            dataList={dataList.data}
            onSourcesChanged={this.onSourcesChanged}
            data={data.documentSources}
          />

          <CheckboxTree dataList={dataList.data} onCategoriesChange={this.onCategoriesChange} />

          <PublishedDates
            dataList={dataList.data}
            data={data.publishedDates}
            onDatesChange={this.onDatesChange}
          />

          <Footer lang={strings.getLanguage()}>
            <RoundedButton onClick={this.applyFilters}>
              {strings.filters.filterButton}
            </RoundedButton>
            <TransparentButton onClick={this.resetFilters}>
              {strings.filters.clear}
            </TransparentButton>
          </Footer>
        </div>
      </Content>
    );
  }
}

const mapStateToProps = state => {
  return {
    filters: state.filters,
    dataList: state.datahub.dataList
  };
};

const mapDispatchToProps = dispatch => {
  return {
    handleFilters: filters => {
      dispatch(setCategories(filters.categories));
      dispatch(setPublishedDates(filters.publishedDates));
      dispatch(setDocumentTypes(filters.documentTypes));
      dispatch(setDocumentSources(filters.documentSources));
      dispatch(getData());
      const queryParams = filterData(filters);
      dataService.getDataList(queryParams).then(response => {
        dispatch(dataReceived(response));
      });
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AdvancedFilters);

export const Content = styled.div`
  .filter-sidebar {
    background-color: #fff;
    display: none;

    @media screen and (min-width: 768px) {
      display: block;
    }

    @media screen and (max-width: 768px) {
      &.is-active {
        display: block;
        position: fixed;
        z-index: 999;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        height: 100vh;
        overflow-y: scroll;
        width: 320px;
      }
    }
  }

  &.expanded {
    .filter-sidebar {
      display: block;
    }
  }

  .heading {
    background-image: linear-gradient(311deg, #288792, #2f80bc);
    padding: 18px 16px;
    border-radius: 4px 4px 0 0;
    display: flex;
    justify-content: space-between;

    > span {
      font-size: ${props => (props.lang === 'en' ? '14px' : '16px')};
    }

    @media screen and (max-width: 768px) {
      border-radius: 0;
    }

    img {
      cursor: pointer;
      @media screen and (min-width: 768px) {
        display: none;
      }
    }
  }

  .toggle-actions {
    display: inline-block;
    img {
      margin-right: 6px;
    }
    .toggle-button {
      @media screen and (max-width: 480px) {
        width: 100%;
      }
    }

    @media screen and (max-width: 480px) {
      display: block;
    }

    @media screen and (min-width: 768px) {
      display: none;
    }
  }
`;

export const Footer = styled.div`
  background: ${props => props.theme.neutrals.shukrabaar};
  border-radius: 0 0 4px 4px;
  padding: 30px 16px;

  ${media.sm`
    display: flex;
    justify-content: center;
  `};

  button {
    font-size: ${props => (props.lang === 'en' ? '12px' : '14px')};
    &:first-child {
      margin-right: 7px;
    }
  }
`;

const BackgroundShadow = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  left: 0;
  z-index: 10;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
`;



// WEBPACK FOOTER //
// ./src/components/layouts/advancedFilters/advancedFilters.js